import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import FilterBar from "@saleor/components/FilterBar";
import Form from "@saleor/components/Form";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import useUser from "@saleor/hooks/useUser";
import { maybe } from "@saleor/misc";
import { SearchBrandsPrivate_search_edges_node } from "@saleor/searches/types/SearchBrandsPrivate";
import { SellerList_brandsPrivate_edges_node } from "@saleor/seller/types/SellerList";
import { SellerListUrlSortField } from "@saleor/seller/urls";
import {
  FilterPageProps,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import { FetchMoreProps } from "@saleor/types";
import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import SellerList from "../SellerList";
import {
  createFilterStructure,
  SellerFilterKeys,
  SellerListFilterOpts
} from "./filters";
import SellerBrandDropdown from "./SellerBrandDropdown";
export interface SellerListPageProps
  extends PageListProps,
    FilterPageProps<SellerFilterKeys, SellerListFilterOpts>,
    SortPage<SellerListUrlSortField>,
    TabPageProps {
  brandID: string;
  brandLabel: string;
  brands: SearchBrandsPrivate_search_edges_node[];
  sellers: SellerList_brandsPrivate_edges_node[];
  fetchBrands: (query: string) => void;
  fetchMoreBrands?: FetchMoreProps;
  // onSubmit: (data: SellerBrandFormData) => void;
  onChangeBrand: (brandID: string) => void;
}

export interface SellerBrandFormData {
  sellerBrand: string;
}

const SellerListPage: React.FC<SellerListPageProps> = ({
  brandID,
  brandLabel,
  brands,
  currentTab,
  filterOpts,
  initialSearch,
  fetchBrands,
  fetchMoreBrands,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  currencySymbol,
  onAdd,
  // onSubmit,
  onChangeBrand,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  const [sellerDisplayName, setSellerDisplayName] = useStateFromProps("");
  const sellerBrandChoices = maybe(
    () =>
      brands.map(brand => ({
        label: brand?.name + " - " + brand.legalName,
        value: brand?.id
      })),
    []
  );
  const initialForm: SellerBrandFormData = {
    sellerBrand: ""
  };

  const breadcrumbDirectory = [
    {
      name: "Sellers"
    }
  ];

  useEffect(() => {
    setSellerDisplayName(brandLabel);
  }, [brandLabel]);

  // const handleSubmit = event => {
  //   onSubmit(event);
  // };
  return (
    <Form initial={initialForm} /* onSubmit={handleSubmit}*/ confirmLeave>
      {({ data: formData, change, submit }) => {
        const { user } = useUser();
        // useEffect(() => {
        //   if (formData.sellerBrand !== "") {
        //     submit();
        //   }
        // }, [formData]);

        const handleSelectBrand = createSingleAutocompleteSelectHandler(
          change,
          setSellerDisplayName,
          sellerBrandChoices
        );
        return (
          <Container>
            {user.userType.code === "ACCOUNT_MANAGER" && (
              <div style={{ display: "flex" }}>
                <div style={{ marginLeft: "auto", order: 2, width: "300px" }}>
                  <SellerBrandDropdown
                    brandID={brandID}
                    brands={sellerBrandChoices}
                    data={formData}
                    change={change}
                    fetchBrands={query => fetchBrands(query)}
                    fetchMoreBrands={fetchMoreBrands}
                    onBrandChange={event => {
                      handleSelectBrand(event);
                      onChangeBrand(event.target.value);
                    }}
                    sellerDisplayValue={sellerDisplayName}
                    submit={submit}
                  />
                </div>
              </div>
            )}
            <PageBreadcrumbNavigation items={breadcrumbDirectory} />
            <PageHeader title="Sellers">
              {user.userType.code !== "ACCOUNT_MANAGER" && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={onAdd}
                  id="createSellerBtn"
                >
                  <FormattedMessage
                    defaultMessage="Create Seller"
                    description="button"
                  />
                </Button>
              )}
            </PageHeader>
            <Card>
              <FilterBar
                allTabLabel={intl.formatMessage({
                  defaultMessage: "All",
                  description: "tab name"
                })}
                currencySymbol={currencySymbol}
                currentTab={currentTab}
                tabs={tabs}
                filterStructure={structure}
                searchPlaceholder={intl.formatMessage({
                  defaultMessage: "Search Seller"
                })}
                initialSearch={initialSearch}
                onSearchChange={onSearchChange}
                onFilterChange={onFilterChange}
                onAll={onAll}
                onTabChange={onTabChange}
                onTabDelete={onTabDelete}
                onTabSave={onTabSave}
              />

              <SellerList {...listProps} />
            </Card>
          </Container>
        );
      }}
    </Form>
  );
};

export default SellerListPage;
